import moment from "moment"

//DO NOT USE THIS FUNCTION - DEPRECATED IN 04/28/2025
export const formatCustomDate = (string, split = '/', conf = {}) => {
  const { diffDays, monthType } = conf
  let newDate;
  if (string) {
    let date = moment(string);
    if (diffDays !== 0) {
      date = date.add(diffDays, 'days');
    }
    newDate = monthType ? date.format(`YYYY${split}MM`) : date.format(`YYYY${split}MM${split}DD`);
  } else {
    let date = moment(new Date());
    if (diffDays !== 0) {
      date = date.add(diffDays, 'days');
    }
    newDate = monthType ? date.format(`YYYY${split}MM`) : date.format(`YYYY${split}MM${split}DD`);
  }
  return newDate;
};


export const fixTime = (originalDate) => {
  const date = new Date();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${originalDate} ${hours}:${minutes}:${seconds}`;
};



export const getDateFromDay = (day) => {
  let dayNumber = typeof day === 'string' ? parseInt(day) : day;
  const today = new Date();
  const targetDate = new Date(today.getFullYear(), today.getMonth(), dayNumber);

  if (today.getDate() > dayNumber) {
    targetDate.setMonth(today.getMonth() + 1);
  }
  const formatDate = formatCustomDate(targetDate, '-')

  return formatDate;
}

export const isValidCustomDate = (date) => {
  return moment(date, 'YYYY/MM/DD', true).isValid() || moment(date, 'YYYY-MM-DD', true).isValid();
}
export const verifyDateFormat_xlsx = (date) => {
  const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/;
  return validFormat.test(date);
};

export const isValidDateObject = (date) => Object.prototype.toString.call(date) === '[object Date]'


//NEW DATE FUNCTION AVAILABLE
export const newDate = (conf = {}) => {
  const { date = "", split = '-', diffDays = 0, monthType = false } = conf;
  let nDate = date ? moment(date) : moment(new Date());

  if (diffDays !== 0) {
    nDate = nDate.add(diffDays, 'days');
  }

  const format = monthType ? `YYYY${split}MM` : `YYYY${split}MM${split}DD`;

  return nDate.format(format);
};


export const newDateWithTime = (conf = {}) => {
  const { date = "", format = false, diffDays = 0 } = conf;
  let nDate = date ? moment(date) : moment(new Date());
  if (diffDays !== 0) {
    nDate = nDate.add(diffDays, 'days');
  }
  if (format) {
    return nDate.format('YYYY-MM-DD HH:mm:ss');
  }
  return nDate.format('YYYY-MM-DDTHH:mm');
}
